export default {
  name: "Location",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M29.71 2.15a1 1 0 0 0-1.08-.22l-26 10.5c-.39.16-.63.53-.63.94s.26.78.64.92l10.86 4.13 3.85 11.06a1 1 0 0 0 .92.67h.02c.41 0 .77-.25.93-.62l10.7-26.3a.99.99 0 0 0-.21-1.08zM18.37 26.33l-3.13-8.99c-.1-.28-.31-.5-.59-.61l-8.92-3.39 21.44-8.66-8.8 21.65z",
  },
}
